// extracted by mini-css-extract-plugin
export default {"productGallery":"pM-z","inQuickShop":"qM-z"};